import { apiRequest } from "../util/apiUtils";

export const ticketList = async (params) => {
  try {
    const res = await apiRequest("get", `ticket/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const ticketDetails = async (params) => {
  try {
    const res = await apiRequest("get", `ticket/detail/${params?.id}`, {
      queries: {
        ...(params?.type && { type: params?.type }),
      },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const ticketAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `ticket/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const ticketDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `ticket/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const ticketStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `ticket/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const checkTicketExistence = async (payload) => {
  try {
    const res = await apiRequest("patch", `ticket/availability`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const referVerificationDetails = async (params) => {
  try {
    const res = await apiRequest("get", `verification/detail/${params?.code}`, {
      queries: {
        ...(params?.type && { type: params?.type }),
      },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
